'use strict'

$(document).on('click', '.js-add-order', function(){
  let card       = $(this).parents(".card__cart__ui")
  let item_code  = $(this).attr("data-code")
  let counter = 0
  let item_count = {}

  // item_count = {
  //   0 : 1,
  //   1 : 3,
  //   2 : 5
  // }

  $("select", card).each(function(){
    let self = $(this)
    let num = Number(self.val())
    item_count[self.attr("name")] = num
    counter = counter + num
  })

  if( counter > 0 ) {
    $.ajax({
      url: php_vars.order_php,
      method: 'POST',
      data: {
        product_code: item_code,
        num: item_count,
      }
    }).done(function(res){
      console.log({
        dispatch: item_count,
        state: res.state
      })

      switch (res.state) {
        case 'success':
          $.fancybox({
            content: $(".tmpl-order-success").html(),
            closeBtn: false,
            padding: 0,
          })

          let pre = $(".js-cart-num").parents("li")

          $("[data-num]", pre).attr("data-num", res.data.cart)
          $(".js-cart-num", pre)
            .text(res.data.cart)
            .addClass("is-animated")

          setTimeout( () => {
            $(".js-cart-num").removeClass("is-animated")
          }, 600);

          break;
        default:

          $.fancybox({
            content: $(".tmpl-order-error").html(),
            closeBtn: false,
            padding: 0,
          })
          break;
      }
    })

  } else {
    $.fancybox({
      content: $(".tmpl-order-alert").html(),
      closeBtn: false,
      padding: 0,
    })
  }
});



// WEBPACK FOOTER //
// ./_src/js/action/addOrder.js